(function(module) {
    'use strict';
    module.constant('TRANSLATION', {
        new: 'nuevo',
        used: 'usado',
        damaged: 'dañado',
        refurbish: 'reparado',
        na: 'no aplica',
        pending: 'pendiente',
        rejected: 'rechazado',
        accepted: 'aceptado',
        cancelled: 'cancelado',
        work: 'trabajo',
        home: 'casa',
        mobile: 'celular',
        active: 'activo',
        expired: 'expirado',
        highlighted: 'destacado',
        season: 'temporada',
        disabled: 'desactivado'
    });
}(angular.module('emarket.commons')));
